import {
  CommodityFilterByTerm,
  CommodityFilterStatusFlag,
  CommoditySortByTerm,
  SortOrder,
  CommodityConnectionType,
  PersonaType,
} from '@bechtel/types';

export enum DrawerSearchScope {
  ALL = 'ALL',
  ASSIGNED_TO_ME = 'ASSIGNED_TO_ME',
  UNASSIGNED = 'UNASSIGNED',
}
export interface WeldDrawerValuesProps {
  searchByList: CommodityFilterByTerm[];
  sortBy: CommoditySortByTerm;
  sortDir: SortOrder;
  searchScope: DrawerSearchScope;
  isSupportingForeman: boolean;
  isPriority: boolean;
  weldTypes: CommodityConnectionType[];
  weldStatusList: CommodityFilterStatusFlag[];
  weldSizeList: CommodityFilterByTerm[];
}

export interface WeldSearchDrawerProps {
  close: () => void;
  initialValues: WeldDrawerValuesProps;
  onSubmit: (values: WeldDrawerValuesProps) => void;
  drawerForDashboard: boolean;
  personaType?: PersonaType;
}
